import Vue from 'vue'
import sObjetos from '@/aplicacao/_servicos/objetos'

function State() {

    this.ehMobile = false
    this.ehDesktop = true

    this.menuModuloVisivel = true
    this.painelVisivel = false
    this.contatoVisivel = false

    this.layoutConteudo = ''

}

const mutations = {

    resetar(stateParam) { sObjetos.preencher(stateParam, new State()) },

    setEhMobile(state, payload) { state.ehMobile = payload },
    setEhDesktop(state, payload) { state.ehDesktop = payload },

    setMenuModuloVisivel(state, payload) { state.menuModuloVisivel = payload },
    setPainelVisivel(state, payload) { state.painelVisivel = payload },
    setContatoVisivel(state, payload) { state.contatoVisivel = payload },

    setLayout(state, payload) { state.layoutConteudo = payload },

}

const actions = {

    resetar({ commit }, payload) { commit('resetar', payload) },

    setTitulo({}, payload) { document.title = process.env.VUE_APP_NAME + ' | ' + payload },
    setLayout({ commit }, payload) { commit('setLayout', payload) },

    irParaTopo({ state }, payload) { if (state.ehMobile) { window.scrollTo(0, 0) } else { document.getElementById('conteudo').scrollTo(0, 0) } },
    irParaFim({ state }, payload) { if (state.ehMobile) { window.scrollTo(0, document.body.scrollHeight) } else { document.getElementById('conteudo').scrollTo(0, document.body.scrollHeight) } },

    setMobile({ commit }, payload) { commit('setEhMobile', true); commit('setEhDesktop', false); commit('setMenuModuloVisivel', false) },
    setDesktop({ commit }, payload) { commit('setEhMobile', false); commit('setEhDesktop', true); commit('setMenuModuloVisivel', true) },

    menuModuloToggle({ dispatch, state }) { state.menuModulosVisivel ? dispatch('menuModuloOcultar') : dispatch('menuModuloMostrar'); },
    menuModuloMostrar({ commit, state }, payload) { commit('setMenuModuloVisivel', true); document.body.style.overflow = 'hidden' },
    menuModuloOcultar({ commit, state }, payload) { commit('setMenuModuloVisivel', false); document.body.style.overflow = 'auto' },

    painelMostrar({ commit }, payload) { commit('setPainelVisivel', true); document.body.style.overflow = 'hidden' },
    painelOcultar({ commit }, payload) { commit('setPainelVisivel', false); document.body.style.overflow = 'auto' },

    contatoMostrar({ commit }, payload) { commit('setContatoVisivel', true) },
    contatoOcultar({ commit }, payload) { commit('setContatoVisivel', false) },

    tratarResponsividade({ commit, dispatch, state }, payload) {
        if ((1200 > window.innerWidth) && !state.ehMobile) {
            dispatch('setMobile')
        } else if ((1200 <= window.innerWidth) && state.ehMobile) {
            dispatch('setDesktop')
        }
    },

}

const getters = {

    sistemaNome: () => process.env.VUE_APP_NAME,

    moduloNome: () => { let nome = false; Vue.router.currentRoute.matched.forEach(route => { if (route.hasOwnProperty('meta') && route.meta.hasOwnProperty('modulo')) { nome = route.meta.modulo } }); return nome },
    moduloTemMenu: () => { let temMenu = false; Vue.router.currentRoute.matched.forEach(route => { if (route.hasOwnProperty('meta') && route.meta.hasOwnProperty('menu') && route.meta.menu) { temMenu = true } }); return temMenu },

}

export default {
    state: new State(),
    mutations,
    actions,
    getters,
}
